import React, { useState, useCallback } from 'react'
import { Formik, Form } from 'formik'
import { Link, useHistory } from 'react-router-dom'
import { useModal } from 'react-modal-hook'
import { useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import CheckMarkIcon from 'custom/assets/icons/requests/709510'
import Modal from '../../../../components/Modal/Modal'
import { useTranslation } from 'react-i18next'
import { REQUESTS_KEYS, DIALOG_KEYS, SIDENAV_KEYS, VALIDATION_MESSAGES } from '../../../../utils/translation-constants'
import {
  accountsSelector,
  carouselCurrentItemSelector,
  getFeatureListSelector,
} from '../../../../selectors'
import { ChequeStatusSchema } from '../../../../schemas/requests'
import RequestService from '../../../../services/requests.service'
import InputError from '../../../../components/InputError/InputError'
import NeoButton from '../../../../components/NeoButton/NeoButton'
import NeoInput from '../../../../components/NeoInput/NeoInput'
import NeoOTP from '../../../../components/FormComponents/NeoOTP'
import LayoutWithAccountCard from '../../../../layout/Layout/layout-account-card'

import AccountDisplay from '../../../../components/account-display/account-display'

import validationConfig from 'custom/config/validation.config.json'
const chequeStatusConfig = validationConfig['OtherService']['chequeStatus']

function ChequeStatus() {
  const { t } = useTranslation()
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [message, setMessage] = useState('')
  const [otp, setOtp] = useState('')
  const [responseValues, setResponseValues] = useState({})
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const featureDetails = featureList['CHEQUE_STATUS']

  const history = useHistory()

  const chequeStatus = {
    N: t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.NOT_UTILIZED),
    U: t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.UTILIZED),
    S: t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.STOPPED),
    R: t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REJECT),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP loading={loading} otp={otp} setOTP={setOtp} onSubmit={confirmChequeStatusForm} />
        )
      case 4:
        return renderSuccess()
      default:
        return renderForm()
    }
  }

  const submitChequeStatusForm = useCallback(
    async (data, { setSubmitting }) => {
      try {
        const featureDetails = featureList['CHEQUE_STATUS']
        if (featureDetails[currentAccountDetail['accountType']] === 'N') {
          setMessage({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }

        setSubmitting(true)
        setFormValues(data)
        const response = await RequestService.verifyChequeStatus({
          accountNumber: currentAccountDetail?.accountNo,
          chequeNumber: data.chequeNumber,
          brnCode: currentAccountDetail?.brnCode,
        })
        if (response.status === 200) {
          setSubmitting(false)
          setLoading(false)
          // if (response.data['otpEnable']) {
          setOtpEnabled(response.data['otpEnable'])
          setLoading(false)
          setStage(2)
          // return
          // }
          // await confirmChequeStatusForm()
        }

        // if (response.otpEnable) {
        //   setStage(2)
        //   setLoading(false)
        // } else {
        //   setLoading(false)
        //   await confirmChequeStatusForm()
        // }
      } catch (err) {
        setSubmitting(false)
        setLoading(false)
      }
    },
    [currentAccountDetail, showModal, featureList],
  )

  const confirmChequeStatusForm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.changeChequeStatus({
        accountNumber: currentAccountDetail?.accountNo,
        chequeNumber: formValues.chequeNumber,
        otp,
        brnCode: currentAccountDetail?.brnCode,
      })
      if (response.status === 200) {
        setResponseValues(response.data)
        setStage(4)
      }
      // setResponseValues(response)
      // setLoading(false)
      // setStage(5)
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [otp, formValues, currentAccountDetail])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>
          {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.TITLE)}{' '}
        </div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={{
            accountNumber: '',
            chequeNumber: '',
          }}
          validationSchema={ChequeStatusSchema}
          onSubmit={submitChequeStatusForm}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={chequeStatusConfig['isChequeNoRequired']}
                  text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE_NUMBER)}
                  onChange={handleChange}
                  name='chequeNumber'
                />
                <InputError text={errors.chequeNumber} touched={touched.chequeNumber} />
              </div>
              <div className='mt-3 form-group'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='2'
                    type='submit'
                    mode='newDesign'
                    disabled={isSubmitting}
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'3'} onClick={() => history.goBack()}>
                {' '}
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.SUBTITLE)}</h3>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div>
          <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE)}</h6>
          <h6 className='value'>{formValues.chequeNumber}</h6>
        </div>
        <div className='mt-3'>
          {loading ? (
            renderLoading()
          ) : (
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CONFIRM)}
              onClick={() => (otpEnabled ? setStage(3) : confirmChequeStatusForm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {' '}
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderSuccess() {
    return (
      <div className='d-flex flex-column'>
        <div className='row justify-content-center align-items-center' style={{ marginBottom: 20 }}>
          <CheckMarkIcon height='150px' width='150px' />
        </div>
        <div className='d-flex flex-column confirmation'>
          <h3 style={{ textAlign: 'center' }}>
            {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE_STATUS)}
          </h3>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.ACCOUNTNO)}
            </h6>
            <h6 className='value'>{responseValues?.accountNo}</h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.CHEQUE_NUMBER)}
            </h6>
            <h6 className='value'>{responseValues.chequeNo}</h6>
          </div>
          <div>
            <h6 className='label'>{t(REQUESTS_KEYS.CHEQUE_KEYS.CHEQUE_STATUS_KEYS.status)}</h6>
            <h6 className='value'>
              {chequeStatus[responseValues.chequeStatus]}
              {/* {responseValues.chequeStatus === 'N'
                ? (t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.NOT_UTILIZED))
                : responseValues.chequeStatus === 'U'
                ? (t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.UTILIZED))
                : (t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REJECT))} */}
              {/* {responseValues.chequeStatus ==='U'}
            {responseValues.chequeStatus ==='R'} */}
            </h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.BENEFICIARY_ACCOUNT)}
            </h6>
            <h6 className='value'>{responseValues.beneAccNo || '-'}</h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.DATE_ON_CHECK)}
            </h6>
            <h6 className='value'>{responseValues.dateOnCheque || '-'}</h6>
          </div>
        </div>
        <div className='mt-4 mx-auto px-0 col-3'>
          <Link to='/requests'>
            <NeoButton
              type='button'
              mode='newDesign'
              text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.DONE)}
            />
          </Link>
        </div>
      </div>
    )
  }

  // const stageCallback = useCallback(() => {
  //   const startStage = 1
  //   if (stage === startStage) {
  //     history.goBack()
  //   } else if (stage - 1 >= startStage) {
  //     const newStage = stage - 1
  //     setStage(newStage)
  //   }
  // }, [stage])

  // function renderBackButton() {
  //   return (
  //     <div
  //       className='mx-2 mb-4 cursor-pointer font-weight-600'
  //       style={{ fontSize: 12, width: 'fit-content' }}
  //       onClick={stageCallback}>
  //       <img className='mr-4' src={BackArrow} />
  //       Back to Cheque Options
  //     </div>
  //   )
  // }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_CHEQUE_STATUS'>
      {/* <div className='row'>
        <div className='col-7 d-flex'>
          <div>
            <img src={menuDetails.icon} alt='statement icon' />
          </div>
          <div>
            <span className='font-weight-bold'>{menuDetails.title}</span>
            <span className='header-title-section'>
              <p>{menuDetails.desc}</p>
            </span>
          </div>
        </div>
        <div className='col-5 text-right'></div>
      </div> */}
      {/* {stage !== 5 && stage !== 4 && renderBackButton()} */}
      {featureDetails[currentAccountDetail['accountType']] !== 'N' && (
        <div className='new-design-form-style'>{renderSwitch()}</div>
      )}

      {featureDetails[currentAccountDetail['accountType']] === 'N' && (
        <div className='no-data-found'>{t(VALIDATION_MESSAGES.NO_ACCESS)}</div>
      )}
      {/* <div>
        <h4 className='font-weight-bold'>Requests</h4>
        <p className='lead text-secondary'>Please select your request type to proceed.</p>
        <div className='my-4 d-flex align-items-center'>
          {stage !== 5 ? <NeoButton mode='back' onClick={stageCallback} /> : null}
          <ChequeIcon width={40} height={40} />
          <div className='ml-3'>
            <h5 className='mb-1'>Cheque</h5>
            <p className='small text-secondary mb-0'>
            </p>
          </div>
        </div>
        <h6 className='mt-5 mb-3 font-weight-bold'>Cheque Status</h6>
        {renderSwitch()}
      </div> */}
    </LayoutWithAccountCard>
  )
}

export default ChequeStatus
